module.exports = __webpack_public_path__ + "img/17850_L.48937467.png";